"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eecRanges = eecRanges;
const axios_1 = __importDefault(require("axios"));
const FALLBACK_ENDPOINT = "https://web-api.audi.com";
const API = "/eec-carline-ranges/v1";
const carlineCache = {};
/* eslint-disable no-unsafe-optional-chaining */
function eecRanges(carlineId, locale, configs) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            if (!carlineCache[locale]) {
                const carlineRanges = yield readAllRangesFromAPI(locale, configs);
                if (carlineRanges) {
                    carlineCache[locale] = carlineRanges;
                }
            }
            return (_a = carlineCache[locale]) === null || _a === void 0 ? void 0 : _a.Carlines.find((carline) => carline.carlineId === carlineId);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            return undefined;
        }
    });
}
function readAllRangesFromAPI(locale, configs) {
    return __awaiter(this, void 0, void 0, function* () {
        let rangeAPI = FALLBACK_ENDPOINT;
        if (configs && configs.VUE_AGW_ENDPOINT) {
            rangeAPI = configs.VUE_AGW_ENDPOINT;
        }
        rangeAPI = `${rangeAPI}${API}`;
        const [language, country] = locale.split("-");
        ///eec-ranges/<country>/<language> ?
        const url = `${rangeAPI}/${country}/${language}`;
        const resp = yield axios_1.default.get(`${url}`, {
            headers: { "Content-Type": "application/json" },
        });
        return resp.data;
    });
}
